module.exports = __webpack_public_path__ + "img/checkbox.5f2fc170.svg";